import React from "react";
import Column from "@amzn/meridian/column";
import Image from "@amzn/meridian/image";
import leftImgSrc from "../../../shared/images/desktop/EligibleProduct1.png";
import rightImgSrc from "../../../shared/images/desktop/EligibleProduct2.png";
import rightImgCASrc from "../../../shared/images/desktop/EligibleProduct2_CA.png";
import plugfonesAllertSrc from "../../../shared/images/desktop/plugfones-alert.jpg";
import plugfonesMercenaryLTSrc from "../../../shared/images/desktop/plugfones-mercenary-lt.jpg";
import { PLUGFONES, ELGINUSA, EligibleProductText } from "../../../shared";
import {
  PLUGFONES_TITLE,
  PLUGFONES_ALLERT_TITLE,
  PLUGFONES_SOVEREIGN_TITLE,
  ELGIN_TITLE,
  PLUGFONES_MERCENARY_LT_TITLE,
} from "../../../shared/constants/messages";
import {
  PLUGFONES_SOVEREIGN_FR,
  PLUGFONES_SOVEREIGN_EN,
  PLUGFONES_MERCENARY_LT_INDEX,
  PLUGFONES_ALLERT_INDEX,
} from "src/components/shared/constants/paths";
import useCountryCodeContext from "src/components/shared/context/useCountryCodeContext";
import useLocaleContext from "src/components/shared/context/useLocaleContext";
import useSiteCodeContext from "src/components/shared/context/useSiteCodeContext";
import {
  isCountryCodeCanada,
  getMercenaryLTUrlByLanguage,
  getPlugfonesFreeReignVTUrls,
  getPlugfonesAllertUrls,
} from "src/components/shared/utils/utils";
import { LOCALE_VALUES } from "src/constants";
import { doesSiteBelongToSortCenter } from "src/components/shared/utils/utils";

const Product = ({ title, priceIndex, productIndex, imgSrc, url }) => {
  return (
    <Column spacing="400">
      <Image src={imgSrc} size="contain" viewportHeight={250} />
      <EligibleProductText
        priceIndex={priceIndex}
        title={title}
        productIndex={productIndex}
        url={url}
      ></EligibleProductText>
    </Column>
  );
};

const ProductMobile = () => {
  const { countryCodeValue: countryCode } = useCountryCodeContext();
  const { language } = useLocaleContext();
  const siteCode = useSiteCodeContext();
  const isSortCenter = doesSiteBelongToSortCenter(siteCode);

  if (isSortCenter) {
    return (
      <Column spacing="600">
        <Product
          title={PLUGFONES_ALLERT_TITLE}
          priceIndex={PLUGFONES_ALLERT_INDEX}
          productIndex={4}
          imgSrc={plugfonesAllertSrc}
          url={getPlugfonesAllertUrls(language)}
        ></Product>
        <Column height={"100px"}></Column>
      </Column>
    );
  }

  return (
    <Column spacing="600">
      <Product
        title={PLUGFONES_TITLE}
        priceIndex={PLUGFONES}
        productIndex={0}
        imgSrc={leftImgSrc}
        url={getPlugfonesFreeReignVTUrls(language)}
      ></Product>
      {isCountryCodeCanada(countryCode) ? (
        <Product
          title={PLUGFONES_SOVEREIGN_TITLE}
          priceIndex={PLUGFONES_SOVEREIGN_EN}
          productIndex={2}
          imgSrc={rightImgCASrc}
          url={
            language === LOCALE_VALUES.FR_CA
              ? PLUGFONES_SOVEREIGN_FR
              : PLUGFONES_SOVEREIGN_EN
          }
        ></Product>
      ) : (
        <Product
          title={ELGIN_TITLE}
          priceIndex={ELGINUSA}
          productIndex={1}
          imgSrc={rightImgSrc}
          url={ELGINUSA}
        ></Product>
      )}
      <Product
        title={PLUGFONES_MERCENARY_LT_TITLE}
        priceIndex={PLUGFONES_MERCENARY_LT_INDEX}
        productIndex={3}
        imgSrc={plugfonesMercenaryLTSrc}
        url={getMercenaryLTUrlByLanguage(language)}
      ></Product>
      <Column height={"100px"}></Column>
    </Column>
  );
};

export default ProductMobile;
